import React from 'react';
import { AuraRing } from './AuraRing';
import { hiResAvatar } from '../utils/avatar';

const ROWS = [
  { need: 6, title: 'Aura I' },
  { need: 5, title: 'Aura II' },
  { need: 4, title: 'Aura III' },
];

/* Compact member tile sized to fit three rows on one screen. */
const MiniCard = ({ u, tier, onOpen, testId, hidden }) => (
  <button type="button" onClick={onOpen} data-testid={testId} aria-hidden={hidden || undefined} tabIndex={hidden ? -1 : 0}
    className="mr-3 w-[104px] h-full flex-shrink-0 rounded-2xl flex flex-col items-center justify-center gap-1 px-2 active:scale-95 transition-transform"
    style={{ background: 'linear-gradient(180deg, rgba(20,20,34,0.85), rgba(5,5,10,0.9))', border: `1px solid ${tier.accent}80`, boxShadow: `0 0 14px ${tier.accent}33` }}>
    <span className="font-['Outfit'] text-[9px] px-1.5 rounded-full" style={{ color: tier.rankText || '#000', background: tier.accentSoft }}>#{u.rank}</span>
    <AuraRing size={58} data={u.aura_ring || { fused: {}, gold: false }}>
      <div className="w-11 h-11 rounded-full overflow-hidden" style={{ border: `1.5px solid ${tier.accent}AA` }}>
        {u.profile_picture
          ? <img src={hiResAvatar(u.profile_picture)} alt={u.nickname} className="w-full h-full object-cover" />
          : <div className="w-full h-full flex items-center justify-center font-['Cormorant_Garamond'] text-lg" style={{ background: `linear-gradient(135deg, ${tier.accent}55, #05050A)`, color: tier.accentSoft }}>{(u.nickname || 'A')[0].toUpperCase()}</div>}
      </div>
    </AuraRing>
    <p className="font-['Cormorant_Garamond'] text-white text-[13px] leading-tight truncate w-full text-center">{u.nickname || 'Member'}</p>
    <p className="font-['Outfit'] text-[8.5px] uppercase tracking-[0.14em]" style={{ color: tier.accentSoft }}>{u.fused_count}/6 auras</p>
  </button>
);

/* Row: static when ≤2 members, otherwise endless auto-scroll (seamless: every item carries its own right margin). */
const Row = ({ row, members, tier, navigate }) => {
  const moving = members.length > 2;
  const open = (u) => navigate(`/user/${encodeURIComponent(u.email)}`);
  return (
    <div className="flex-1 min-h-0 flex flex-col" data-testid={`aura-row-${row.need}`}>
      <p className="text-center mb-1.5 flex-shrink-0 font-['Cinzel'] text-[14px] tracking-[0.3em]" style={{ color: tier.accentSoft, textShadow: `0 0 12px ${tier.accent}66` }}>{row.title}</p>
      {members.length === 0 ? (
        <p className="px-4 font-['Cormorant_Garamond'] italic text-sm" style={{ color: `${tier.accent}80` }}>No one here yet — be the first.</p>
      ) : (
        <div className="flex-1 min-h-0 overflow-hidden pl-4">
          <div className={`flex h-full w-max ${moving ? 'aura-marquee' : ''}`} style={moving ? { animationDuration: `${members.length * 4}s` } : undefined}>
            {members.map((u, i) => <MiniCard key={u.email} u={u} tier={tier} onOpen={() => open(u)} testId={`aura-member-${row.need}-${i}`} />)}
            {moving && members.map((u, i) => <MiniCard key={`c-${u.email}`} u={u} tier={tier} onOpen={() => open(u)} testId={`aura-member-${row.need}-clone-${i}`} hidden />)}
          </div>
        </div>
      )}
    </div>
  );
};

export const AuraTierRows = ({ members, tier, navigate }) => (
  <div className="h-full flex flex-col gap-3 pt-3" style={{ paddingBottom: 'calc(10px + var(--safe-area-inset-bottom, 0px))' }}>
    <style>{'@keyframes auraMarquee{from{transform:translateX(0)}to{transform:translateX(-50%)}}.aura-marquee{animation:auraMarquee linear infinite}.aura-marquee:active{animation-play-state:paused}'}</style>
    {ROWS.map((row) => (
      <Row key={row.need} row={row} tier={tier} navigate={navigate} members={members.filter((m) => m.fused_count === row.need)} />
    ))}
    <p className="px-6 text-center font-['Outfit'] text-[9px] text-white/35 flex-shrink-0">Ranked by pillars fused yesterday · refreshes every midnight</p>
  </div>
);

export default AuraTierRows;
